import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'
import { FilterTypeStrings } from 'enums/FilterType'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { getTwEmoji } from 'utils/emojiUtil'
import { isRightToLeftText, RTL_MARK } from 'utils/rtlTextUtil'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import emojiRegex from 'emoji-regex'
import { toFilter } from '../../../../../utils/widgetUtil'
import { TrendingWidgetsType } from '../../types'

export const getDisplayText = (
  name: string,
  viewOption: InsightViewOptionStrings,
  emojiNameToDisplayMap: Record<string, string>
) => {
  switch (viewOption) {
    case InsightViewOption.EMOJIS_EMOJI:
    case InsightViewOption.EMOJIS_EMOTION:
    case InsightViewOption.EMOJIS_GROUP:
      if (emojiNameToDisplayMap[name]) {
        if (getTwEmoji(emojiNameToDisplayMap[name])) {
          return getTwEmoji(emojiNameToDisplayMap[name])
        }
        return emojiNameToDisplayMap[name]
      }
      return name
    default:
      if (isRightToLeftText(name) && name.charAt(0) === '#') {
        return RTL_MARK + name
      }
      return emojiRegex().test(name) ? getTwEmoji(name) : name
  }
}

export const resolveTooltip = (
  selectedInsight: InsightData,
  viewOption: InsightViewOptionStrings,
  emojiNameToDisplayMap: Record<string, string>
) => {
  const formattedName = getDisplayText(selectedInsight.name!, viewOption, emojiNameToDisplayMap)
  if (selectedInsight.variants && selectedInsight.variants.length > 0) {
    return `${formattedName}, ${selectedInsight.variants.join(', ')}`
  }

  return formattedName
}

export const convertToInsightContentSetting = (
  widgetSetting: TrendingWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  const { viewOption } = widgetSetting
  const insights = selection ? selection?.insights : null
  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic?.topicId,
    insights,
    displayTitleTooltip: false
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (insights && insights.length > 0) {
    if (insights?.[0]?.name) {
      insightContentSetting.selectionName = insights?.[0]?.name
      if (insights.length > 1) {
        if (insights.length === 2 && insights?.[1]?.name) {
          insightContentSetting.selectionSecondName = insights?.[1]?.name
        }
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: TrendingWidgetsType,
  strategy: WidgetSettingComposingStrategy,
  selection: { insights?: Array<InsightData> }
) => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    return composeDrillDownWidgetSetting(strategy, widgetSetting, selection.insights!)
  }
  return {}
}
